import { render } from "./FormError.vue?vue&type=template&id=1bd2a46e&scoped=true"
import script from "./FormError.vue?vue&type=script&lang=js"
export * from "./FormError.vue?vue&type=script&lang=js"

import "./FormError.vue?vue&type=style&index=0&id=1bd2a46e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bd2a46e"

export default script